import loadAsset from './modules/load-assets';
import easy from './modules/easyReveal';
import lazy from './modules/lazy-image-load';
import findPosition from './modules/find-position'; 
import carousel from './modules/carousel'; 
import listen from './modules/listener'; 
// import async from './modules/async'; 
import forms from './modules/forms'; 

const v = document.querySelector('[data-version]').getAttribute('data-version');
console.log( `VERSION ${v}` );

const theme =  `/wp-content/themes/${ location.href.includes('localhost') ? 'vhf-brand-cms-site' : 'veterinary-hope' }`;

//Set initial position
let position = findPosition();
//initialize lazy load of images
lazy.init();
easy.init();

//load fonts
load.asset(`${theme}/fonts.css`, 'link');

const dynamicVideos = document.querySelector('[data-dynamic-video]');
if( dynamicVideos ) {
     let videoStyles = false; //makes sure that videJS stylesheet is only loaded once per session
     console.log('loading videoJS'); 
     const initVideos = function() {
          !videoStyles ? load.asset('//vjs.zencdn.net/7.10.2/video-js.min.css', 'link', () => { videoStyles = true; }) : false;
          const id = dynamicVideos.getAttribute('id');
          console.log('id', id);
          const videoPlayer = id ? videojs( id ) : false;
          videoPlayer.ready( () => {
               console.log('player ready');
               const player = this;  
               setTimeout(() => {
                    console.log('play');
                    // player.play();
                }, 500);
          } );
      }
      //Make sure the library is loaded
      window.videojs ? initVideos() : load.asset('//vjs.zencdn.net/7.10.2/video.min.js', 'script', initVideos)
}

const registration = document.querySelector('[data-registration-form]');
if( registration ) {

     function updateFormStage( stage ) {
          const calculation = Number(stage) * ( 100/questionFrames.length);
          const translate = ( calculation * -1);
          frame.style.transform = `translateX(${translate}%)`;
          indicatorLine.style.width = `${calculation + 15}%`;
          steps.forEach( step => {
               const thisStage = step.getAttribute('data-form-stage-indicator');
               thisStage <= stage && !step.classList.contains('active') ? step.classList.add('active') : false;
               thisStage > stage ? step.classList.remove('active') : false;
          } );
     }

     let stage = 0;
     let frame = document.querySelector('.jsFrameContainer');
     const questionFrames = document.querySelectorAll('.component-form__questions');
     const steps = document.querySelectorAll('.jsFormIndicationStep');
     const indicatorLine = document.querySelector('.jsFormCompletionIndicator');
     frame.style.width = `${questionFrames.length * 100}%`;
     questionFrames.forEach( frame => {
          frame.style.width = `${ 100 / questionFrames.length}%`;
     } );
     listen('[data-form-stage]', event => {
          event.preventDefault();
          event.stopPropagation();
          const sendStage = event.target.getAttribute('data-form-stage');
          updateFormStage( sendStage );
     })

     registration.addEventListener('submit', event => {
          event.preventDefault();
          const data = forms.serialize( registration );
          console.log('submit', data);
          async.post(response => {
               const result = async.process( response );
               if( result.hasOwnProperty('success') && result.success ) {
                    updateFormStage( steps.length-1 );
               } else {
                    console.log('error', result.response)
               }
          },
          `https://vethope.wpengine.com/api/add-registrant.php`,
          data);
     })
}

const newsletterSubscribeForm = [...document.querySelectorAll('[data-form="newsletter_subscribe"]')];
if( newsletterSubscribeForm.length > 0 ) {
     console.log('found');
     newsletterSubscribeForm.forEach( form => {
          var locked = false;
          form.addEventListener('submit', event => {
               event.preventDefault();
               if( !locked ) {
                    locked = true;
                    //show thinking state
                    form.classList.add('awaiting-response');
                    //removal all ul.form-errors from inside of form
                    const currentErrors = form.querySelectorAll( '.form-error' );
                    currentErrors.forEach( error => {
                         error.remove();
                    } )
                    //determine our data's destination
                    const endpoint = form.getAttribute('data-endpoint');
                    //stop form submitting normally
                    event.preventDefault();
                    // data-endpoint="<?php echo admin_url('admin-ajax.php'); ?>"
                    //grab form data and convert to something readable by PHP
                    const data = forms.serialize( form );
                    console.log('submit', data);
                    
                    fetch(endpoint, {
                         method: 'POST',
                         headers: {
                              'Content-Type': 'application/x-www-form-urlencoded',
                         },
                         body: new URLSearchParams(data),
                    })
                         .then(response => {
                              //remove thinking state
                              form.classList.remove('awaiting-response');
                              locked = false;
                              // Check if the request was successful (status code 200-299)
                              if (!response.ok) {
                                   throw new Error(`Network response was not ok: ${response.statusText}`);
                              }
                              // Parse the JSON in the response
                              return response.json();
                         })
                         .then(data => {
                              // Handle the data
                              // console.log('Data:', data);

                              if( !data.success ) {
                                   // validation error
                                   if( data.errors ) {
                                        console.log( 'errors', data.errors )
                                        data.errors.forEach( error => {
                                             const el = form.querySelector(`[name=${error.field}]`);
                                             el.insertAdjacentHTML('afterend', `<div class="form-error">${error.message}</div>`)
                                        } )
                                   } else {
                                        // MC error
                                   }

                              } else {
                                   console.log('victory')
                                   form.closest( '.component-form-stages' ).classList.add('complete')
                              }
                         
                              // sort errors by field
                                   //create ul for each, add class form-errors
                                   //create li for each error add class

                         })
                         .catch(error => {
                              // Handle errors
                              console.error('Error:', error);
                         });
               }
          })

     })

}

// const formGeneric = [...document.querySelectorAll('[data-form]')];
// if( formGeneric.length > 0 ) {
//      formGeneric.forEach( form => {
//           console.log('form', form);
//           form.addEventListener('submit', event => {
//                console.log('submit', data);
//                //stop form submitting normally
//                event.preventDefault();
//                //grab form data and convert to something readable by PHP
//                const data = forms.serialize( form );
//                //determine our data's destination, w/ fallback
//                const endpoint = form.getAttribute( 'action' ) || `https://vethope.wpengine.com/api/add-registration.php`;
               
//                async.post(response => {
//                     const result = async.process( response );
//                     if( result.hasOwnProperty('success') && result.success ) {
//                          form.querySelector('.jsFormStateController').classList.add('active');
//                     } else {
//                          console.log('error', result.response)
//                     }
//                },
//                endpoint,
//                data);
//           })
//      } )
// }

/***********************************
// Carousels
************************************/
const carousels = document.querySelectorAll( '[data-carousel]' );
if( carousels.length > 0 ) {
     console.log('found');
     window.siema ? initCarousels( carousels ) : load.asset(`${theme}/assets/js/vendor/siema.min.js`, 'script', () => { initCarousels(carousels) });
}

const drawers = document.querySelectorAll('[data-component-accordion]');
if( drawers.length > 0 ) {
     drawers.forEach( drawer => {
          drawer.addEventListener( 'click', ()=>{
            drawer.classList.toggle('active');
            const container = drawer.nextElementSibling;
            const height = container.clientHeight;
            const scroll = container.scrollHeight;
            console.log( container, height, scroll );
            height < scroll ? container.style.maxHeight = `${scroll}px` : container.style.maxHeight = 0;
          }, {passive:true} );
     } )
}


/***********************************
// Load More
************************************/
// const more = document.querySelector('[data-load-more]');
// if( more ) {
//      const loadPoint = document.querySelector('[data-load-point]');
//      let loadLock = false;
//      const list = ['filter', 'taxonomy', 'max', 'page'];
//      more.addEventListener('click', () => {
//           if( !loadLock ) {
//                let page = Number(more.getAttribute('data-page'));
//                const endpoint = more.getAttribute('data-link'); 
//                const max = Number(more.getAttribute('data-max'));
//                let data = new FormData();
//                list.forEach( attr => {
//                     data.append(attr, more.getAttribute(`data-${attr}`));
//                })
//                data.append('action','load_more')
//                more.classList.add('loading');
//                async.post( response => {
//                     loadLock = true;
//                     more.classList.remove('loading');
//                     page >= max ? more.parentNode.removeChild(more) : more.setAttribute('data-page', page + 1 );
//                     console.log(Number(more.getAttribute('data-page')))
//                     loadPoint.innerHTML += async.process(response);
//                     lazy.add();
//                     setTimeout( () => { 
//                          console.log( loadLock );
//                          loadLock = false;
//                     }, 2500 );
//                }, endpoint, data);
//           }
//      }, { passive: true });
// }